const Card_details=[
    {
        Tital:"Daily Show",
        Discription:"Designed 1st End-to End Front End project, you can search any movie and book ticket of that movie",
        img:"./Collection/Daily_show.png",
        skils:["./Collection/react.png","./Collection/material_ui.png","./Collection/css.jpg"],
        github:"https://github.com/choudhary-ankit/Front-End-Project/tree/master/daily_shows",
        sites:"https://dailyshow.netlify.app/"

    },
    {
        Tital:"Swiggy",
        Discription:"Designed Swiggy webpage, you can select location,resturent, food as per your choise",
        img:"./Collection/swiggy.png",
        skils:["./Collection/react.png","./Collection/material_ui.png","./Collection/css.jpg"],
        github:"https://github.com/choudhary-ankit/swiggycloneApp",
        sites:"https://swiggy-clone.netlify.app/"

    },
    {
        Tital:"Flipkart",
        Discription:"Designed Flipkart Landing page by using React App",
        img:"./Collection/flipkart.png",
        skils:["./Collection/react.png","./Collection/material_ui.png","./Collection/css.jpg"],
        github:"https://github.com/choudhary-ankit/week-7-project",
        sites:"https://react-flipkart.netlify.app/"

    },
    {
        Tital:"YourPlan",
        Discription:"YourPlan is a static webpage, by using HTML, Css & Bootstarp",
        img:"./Collection/YourPlane.png",
        skils:["./Collection/html.png","./Collection/css.jpg", "./Collection/bootstrap.png"],
        github:"https://github.com/choudhary-ankit/YourPlane-project",
        sites:"https://choudhary-ankit.github.io/YourPlane-project/websiteByusingbootstrap.html"

    },
    {
        Tital:"Sudko Game",
        img:"./Collection/Sudko.png",
        Discription:"This is a real time game, You can easly play. it is designed through HTML, CSS & JavaScripts",
        skils:["./Collection/html.png","./Collection/css.jpg", "./Collection/js.png",],
        github:"https://github.com/choudhary-ankit/SudkoGame",
        sites:"https://choudhary-ankit.github.io/SudkoGame/sudko.html"

    },
    {
        Tital:"Electricity Bill Genrator",
        Discription:"You can easly Calculate your Electricity Bill of your particular elctric item,",
        img:"./Collection/Electricity.png",
        skils:["./Collection/html.png","./Collection/css.jpg", "./Collection/bootstrap.png", "./Collection/js.png"],
        github:"https://github.com/choudhary-ankit/ElectricityBillGenrator",
        sites:"https://choudhary-ankit.github.io/ElectricityBillGenrator/powertracker.html"

    },
   
   
   
]
export default Card_details;